const state= {
    Items:{
        data:[],
        total:0,
        pages: {
            page:1,
            totalPage : 1,
            limit:25,
            filter:{}
        },
    },
    Loadings:{
        list: false,
        detail: false,
    },
    Item: null,
};

const getters = {
    Items : (state) => state.Items,
    Loadings : (state) => state.Loadings,
    Item : (state) => state.Item,
};

const actions = {
    async saveAppVersion({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/app-version`, {
                method: "POST",
                data : params,
                headers: {
                    Accept: "application/json",
                },
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async updateAppVersion({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/app-version/${params.id}`, {
                method: "PUT",
                data : params.data,
                headers: {
                    Accept: "application/json",
                },
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async getItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key:"detail",val:true});
            global.axios.get(`/api/app-version/${params}`)
                .then(response => {
                    commit( 'setLoadings', {key:"detail",val:false});
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getList({commit}, params){
        commit( 'setLoadings', {key:"list",val:true});
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/app-version`, {params:params})
            .then(response => {
                commit( 'setLoadings', {key:"list",val:false});
                response.data.data.pages = params
                commit( 'setListItems', response.data.data );
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    }
};

const mutations = {
    setListItems (state,data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit )
        state.Items.data = data.items
        state.Items.total = data.total
        state.Items.pages = data.pages
    },
    setLoadings (state,data) {
        state.Loadings[data.key] = data.val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}